<div class="tabs">
    @for (type of BUTTON_TYPES; track type) {
        <div class="tab" [class.active]="currentType() === type" (click)="selectType(type)">
            {{ BUTTON_STYLE_TYPE_TRANSLATIONS[type] | translate }}
        </div>
    }
</div>

<!--<div class="panel-options-body overflow-wrapper button-setting-panel">-->
<div class="panel-options-body overflow-wrapper">
    @if (currentButton(); as button) {
        <sp-themes-button-tab
            [colorsPreset]="themeColors()"
            [base]="button.base"
            [hover]="button.hover"
            (valueChangeEvent)="valueChangeHandler($event)"
            (editFontsEvent)="onEditFonts()"
        />
    }
</div>

<div class="panel-options-footer">
    <button type="button" class="btn btn-default mr-10" (click)="onCancel()">{{ "cancel" | translate }}</button>
    <button type="button" class="btn btn-success" (click)="onSave()">{{ "save" | translate }}</button>
</div>
